/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymSuggestionTypeConsultationAliases {
  FIELD_SUGGESTION_TYPE_CONSULTATION = 'field-suggestion-type-consultation',
  FORM_SUGGESTION_TYPE_CONSULTATION = 'form-suggestion-type-consultation',
  LAYOUT_SUGGESTION_TYPE_CONSULTATION = 'layout-suggestion-type-consultation',
  PANEL_SUGGESTION_TYPE_CONSULTATION = 'panel-suggestion-type-consultation',
  RADIO_GROUP_SUGGESTION_TYPE_CONSULTATION = 'radio-group-suggestion-type-consultation',
}
export { PseudonymSuggestionTypeConsultationAliases };
